
import React from "react";
import { useNavigate } from "react-router";


export const Footer = (props) => {
  const navigate = useNavigate();
  
  
  return (
    <div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 {" "}
            <a href="https://diecontainerklinik.de" rel="nofollow">
            die Containerklinik
            </a>
          </p>
          <p>
          <a  onClick={()=>navigate("/impressum")}>
            
            Impressum
            
            </a>
            
            {" "} | {" "}
            
            <a  onClick={()=>navigate("/datenschutz")}>
            
            Datenschutz
            
            </a>
            </p>
        </div>
      </div>
    </div>
  );
};
